module.exports=[{key:"en",value:"en",text:"English (Default)"},{key:"th",value:"th",text:"ภาษาไทย"},{key:"fr",value:"fr",text:"Français"}];